module.exports = __webpack_public_path__ + "static/img/13.014a512.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/13.png
// module id = cXdg
// module chunks = 0